var Type = require('./Type');

/**
 * The BooleanType class represents a boolean data type. BooleanType
 * data can work in two different ways. The first way is the Office
 * Open XML Spreadsheet built-in type that always shows TRUE/FALSE in
 * the users locale. This value can easily be used within formulas.
 *
 * @param {Object} [oConfig] - Configuration object for this numeric representation
 * @param {string} [oConfig.trueValue] - Contains the value that gets displayed if the Boolean is true
 * @param {string} [oConfig.falseValue] - Contains the value that gets displayed if the Boolean is false
 * @constructor
 */
function BooleanType(oConfig) {
	Type.call(this, oConfig);

	this.trueValue = oConfig ? oConfig.trueValue : null;
	this.falseValue = oConfig ? oConfig.falseValue : null;
}

BooleanType.prototype = Object.create(Type.prototype);
BooleanType.prototype.constructor = BooleanType;

BooleanType.DEFAULT = {
	numberFormat: 0
};

/**
 * This method indicates if the properties trueValue and falseValue
 * are configured correctly and the BooleanType supports a custom
 * format.
 *
 * @returns {boolean} - Whether to use a custom formatted BooleanType or the built-in type.
 */
BooleanType.prototype.isCustomFormatted = function() {
	return !!this.trueValue
		&& typeof this.trueValue === 'string'
		&& !!this.falseValue
		&& typeof this.falseValue === 'string';
};

/**
 * Creates the format according to the provided configuration. If the
 * format matches any builtin format, it will return a reference to
 * its ID instead of the format.
 *
 * Both cases can serve the Style class that consumes this information.
 *
 * @returns {Object} - Configuration object for NumberFormat initialization
 * @protected
 */
BooleanType.prototype._createConfiguration = function() {
	var config;

	config = Object.getPrototypeOf(BooleanType.prototype)._createConfiguration.call(this);
	config.numberFormat =
		this.isCustomFormatted() ?
			{ format: '"' + this.trueValue + '";;"' + this.falseValue + '"' } : BooleanType.DEFAULT.numberFormat;

	return config;
};

module.exports = BooleanType;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/binding/type/BooleanType.js
// module id = 14
// module chunks = 0